import apiAthleteScholarship from '@/api/athlete-scholarship'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  athleteScholarship: null
}

export const mutationTypes = {
  updateAthleteScholarshipStart:
    '[update athlete scholarship] Update athlete scholarship start',
  updateAthleteScholarshipSuccess:
    '[update athlete scholarship] Update athlete scholarship success',
  updateAthleteScholarshipFailure:
    '[update athlete scholarship] Update athlete scholarship failure'
}

export const actionTypes = {
  updateAthleteScholarship:
    '[update athlete scholarship] Update athlete scholarship'
}

const mutations = {
  [mutationTypes.updateAthleteScholarshipStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateAthleteScholarshipSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateAthleteScholarshipFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.updateAthleteScholarship](
    context,
    {id, athleteScholarshipInput}
  ) {
    context.commit(mutationTypes.updateAthleteScholarshipStart)
    return new Promise(resolve => {
      apiAthleteScholarship
        .updateAthleteScholarship(id, athleteScholarshipInput)
        .then(response => {
          context.commit(mutationTypes.updateAthleteScholarshipSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateAthleteScholarshipFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
